module.exports = __webpack_public_path__ + "img/图层 10.a6f6b121.png";